import React from 'react';
import { View } from 'react-native';

import Entry from 'app/src/styles/mobileTable';
import { Text } from 'app/src/styles';

const MobileRow = ({ entry, columns, showTimestamps }) => {
  const actionColumn = columns[columns.length - 1];
  const updated = columns[6].content({ entry, value: entry.updatedAt });

  return (
    <Entry.Container>
      <Entry.Title>
        <Text style={{ marginRight: 10 }}>{entry.eventType.name}</Text>
        {entry.things.map(thing => (
          <Text key={thing.id}>
            {thing.emoji || thing.name.substr(0, 8)}{' '}
          </Text>
        ))}
      </Entry.Title>
      <Entry.Text>{columns[0].content({ entry })}</Entry.Text>
      <Entry.Text>{entry.client.name}</Entry.Text>

      {entry.amount && (
        <Entry.Text>
          {entry.eventType.amountLabel || 'Amount'}: {entry.amount}
        </Entry.Text>
      )}

      {entry.durationDescription && (
        <Entry.Text>{entry.durationDescription}</Entry.Text>
      )}

      {!columns[5].hidden && (
        <Entry.Text>
          Created{' '}
          {columns[5].content({ entry, value: entry.createdAt })}
        </Entry.Text>
      )}

      {!columns[6].hidden && updated && (
        <Entry.Text>{updated}</Entry.Text>
      )}

      <View style={{ marginTop: 4 }}>
        {actionColumn.content({ entry })}
      </View>
    </Entry.Container>
  );
};

export default MobileRow;
